import { Heading } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

const NoResultsMessage = ({ searchTerm }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Heading
        as="h4"
        size={{
          base: 'sm',
          md: 'md',
          xl: 'md',
        }}
      >
        {t('NO_RESULTS')} <b>"{searchTerm}"</b>
      </Heading>
    </div>
  );
};

export default NoResultsMessage;
